import { Component, Input } from '@angular/core';

import { FaqHelp } from '../../../../data/help-me/domain/faq-help';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-faq-help',
  templateUrl: './faq-help.component.html',
  styleUrls: ['./faq-help.component.scss'],
})
export class FaqHelpComponent {
  @Input() faq: FaqHelp;
}
